<template>
  <form class="form-horizontal">
    <input-component
      id="name"
      v-model="name"
      :label="trans('core.name')"
      type="text"
      :errormessage="name == '' ? trans('schedule_sync_rules.validation.required', { name: trans('core.name') }) : null"
    />

    <program-selector
      id="program_id"
      v-model="programId"
      :label="trans('core.program')"
      :url="'programs'"
    />

    <date-picker-component
      id="startdate"
      v-model="startdate"
      :label="trans( 'core.startdate')"
      :errormessage="dateError"
    />

    <date-picker-component
      id="enddate"
      v-model="enddate"
      :label="trans( 'core.enddate')"
    />
  </form>
</template>

<script>
import ProgramSelector from '../FormComponents/ProgramSelector.vue'
import InputComponent from '../FormComponents/InputComponent.vue'
import DatePickerComponent from '../FormComponents/DatePickerComponent.vue'

export default {
  components: {
    DatePickerComponent,
    InputComponent,
    ProgramSelector,
  },

  props: {
    value: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      dateError: null,
    }
  },

  computed: {
    name: {
      get () {
        return this.value.name
      },
      set (value) {
        this.emitInput('name', value)
      },
    },

    programId: {
      get () {
        return this.value.programId
      },
      set (value) {
        this.emitInput('programId', value)
      },
    },

    startdate: {
      get () {
        return this.value.startdate
      },
      set (value) {
        this.emitInput('startdate', value)
      },
    },

    enddate: {
      get () {
        return this.value.enddate
      },
      set (value) {
        this.emitInput('enddate', value)
      },
    },
  },
  methods: {
    emitInput (key, value) {
      const newValue = { ...this.value, [key]: value }

      this.$emit('input', newValue)

      this.checkCanFinish(newValue)
    },

    checkCanFinish (value) {
      if (value.startdate > value.enddate) {
        this.dateError = this.trans('schedule_sync_rules.validation.startdate_before_enddate')
      } else {
        this.dateError = null
      }

      if (value.startdate === null || value.enddate === null || value.programId === null || value.name === '' || this.dateError !== null) {
        this.$emit('canNotFinishStep')
      } else {
        this.$emit('canFinishStep')
      }
    },
  },
}
</script>
